import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getStopsListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `stops`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitStopsAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `stops`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateStopsAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `stops/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopsEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `stops/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteStopsApi = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `stops/delete/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteStopsApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await axios.delete(apiUrl + `stops/bulkdelete`, {
      data,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopsViewApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `stops/view/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getActualWorkflowApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `stops/workflow/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEstimateWorkflowApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `stops/est_workflow/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const uploadStopsExcelApi = async (payload) => {
  try {
    const response = await axios.post(apiUrl + `stop_upload`, payload, {
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: getCookie("mawalog"),
      },
    });
    return response;
  } catch (err) {
    console.error("Error uploading Excel file:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const uploadTripExcelApi = async (payload) => {
  try {
    const response = await axios.post(apiUrl + `trip_upload`, payload, {
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: getCookie("mawalog"),
      },
    });
    return response;
  } catch (err) {
    console.error("Error uploading Excel file:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download Stop Template
export const downloadStopTemplateApi = async () => {
  try {
    const response = await axios.post(
      apiUrl + `template_download`,
      { type: "stop" },
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error downloading template:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getCustomerAddressApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `customer/address/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

// Download base64 file utility
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
